import React from "react";

const AboutCompo = () => {
  return (
    <>
      <div className="flex items-center justify-center h-24">
        <h2 className="text-4xl font-bold">About</h2>
      </div>
      <div className="flex flex-col justify-center items-center md:flex-row w-full">
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-3xl font-bold mb-4">Yuvraj Mehandi Artist</h2>
          <p className="text-lg">
            Yuvraj Mehandi Artist specializes in creating stunning and intricate
            mehndi designs that add elegance and charm to every occasion. Our
            artistry is a harmonious blend of tradition and innovation, ensuring
            each design reflects a unique story. Whether it's the timeless
            beauty of bridal mehndi or the vibrant patterns for festive
            celebrations, our expert team dedicates meticulous attention to
            every detail. We take immense pride in crafting designs that not
            only beautify your hands but also resonate with your emotions and
            the essence of the event.
          </p>
          <p className="text-lg mt-4">
            Our passion for mehndi artistry goes beyond just applying designs.
            It’s about creating an unforgettable experience for our clients.
            With years of expertise, we bring precision, creativity, and
            dedication to every stroke, making your mehndi moment truly special.
            Be it a wedding, sangeet, festival, or a casual celebration, Yuvraj
            Mehandi Artist promises to deliver designs that leave a lasting
            impression. Let us transform your mehndi dreams into a masterpiece
            you’ll cherish forever.
          </p>
          <div>
            <a
              href="/about"
              className="block w-full mt-4 px-4 py-2 bg-yellow-400 text-slate-900 font-bold rounded hover:bg-yellow-500 text-center"
            >
              Know More
            </a>
          </div>
        </div>
        <div className="w-full md:w-1/2 p-4">
          <img
            src="/assets/about/about1.jpg"
            alt="Mehndi Art"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>
      </div>
    </>
  );
};

export default AboutCompo;
